var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sizeScroll"},[_c('div',{ref:"songName1",staticClass:"content"},[_c('div',{class:{innerActive: _vm.nameScroll},attrs:{"id":"inner"}},[_c('span',{ref:"first",attrs:{"id":"first"}},[_vm._v(_vm._s(_vm.val))]),_vm._v(" "),_c('span',{attrs:{"id":"second"}},[_vm._v(_vm._s(_vm.val))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07617ca7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marquee.vue
// module id = null
// module chunks = 